import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../data/content";

export const EditorialMarquee = () => {
  return (
    <div className="bg-sand py-8 border-y border-border overflow-hidden" data-testid="editorial-marquee">
      <Marquee speed={26} gradient={false} autoFill>
        {MARQUEE_WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif text-ink text-3xl md:text-5xl italic px-8">
              {w}
            </span>
            <span className="text-sage text-2xl md:text-3xl">✳</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
};
